import { BannerMessageDetails } from "./banner-message-details.model";

export class BannerMessageHidden {
  bannerAuto: number;
  hiddenDate: string;

  constructor(bannerMessage: BannerMessageDetails) {
    this.bannerAuto = bannerMessage.bannerAuto;
    this.hiddenDate = new Date().toISOString();
  }
}
